import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';

const postEasyPostShipment = createAsyncThunk('easyPostShipment/postEasyPostShipment',
  async (formData, { rejectWithValue }) => {
    try {
      const data = await authSet(METHOD_POST, '/shipping/easypost', formData);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default postEasyPostShipment;
